import { RegisterModule } from '@/typings/common'
import {
  RoadmapBaseEvent as Data,
  RoadmapBaseEventCollection as Collection,
} from '@/typings/api/RoadmapBaseEvent'
import { RoadmapBaseEventsApi as Api } from '@/api/resources'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import {
  RoadmapBaseEventsAdapter as Adapter,
} from './RoadmapBaseEventsAdapter'
import { MODULE_NAME } from '../utils'


const useOptions = () => ({
  adapter: new Adapter(),
  idName: 'id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as roadmapBaseEventsStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
